// hooks
import { useQuery } from 'react-query';
import { getFlexMatchAskEmployeeMessage } from 'RestAPIs/flex-match';

export type FlexMatchAskEmployeeMessagePayload = {
  workAgreementId: number;
  processInstanceId: number;
  employeeId: number;
  messageType?: 'phone';
};

const useGetFlexMatchAskEmployeeMessage = (
  {
    workAgreementId,
    processInstanceId,
    employeeId,
    messageType
  }: FlexMatchAskEmployeeMessagePayload,
  options: Record<string, any> = {}
) => {
  return useQuery(
    [
      'flexMatchAskEmployeeMessage',
      workAgreementId,
      processInstanceId,
      employeeId,
      messageType
    ],
    async () => {
      const { data } = await getFlexMatchAskEmployeeMessage({
        workAgreementId,
        processInstanceId,
        employeeId,
        messageType
      });
      return data;
    },
    { ...options }
  );
};

export default useGetFlexMatchAskEmployeeMessage;
